<template>
    <GuideStep3Component
        type="INLINE"
        roleKey="experienceAdd"
        :step="props.step"
        :content="$t('guide.guide_popover_step_7_desc')"
        :buttonText="$t('guide.guide_popover_step_7_btn_edit')"
        :templateTitle="$t('experience.common.inline_template_title')"
        componentName="ExperienceTemplate"
    ></GuideStep3Component>
</template>

<script lang="ts" setup>
import GuideStep3Component from './GuideStep3Component.vue';
import { GuideStep } from '@master/store/guide.store';
interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();
</script>

<style lang="scss" module>
@import '@style/import.scss';
</style>
